import React from "react";
import { Button, Typography } from "@mui/material";
import { Link } from "react-router";
import { getCaseLink } from "@/src/services/productService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import { ArrowForward } from "@mui/icons-material";
import ContentBox from "@/src/components/Box/ContentBox/ContentBox";

type DivorcePlannerBoxProps = {
  product: AbstractCase;
};

const DivorcePlannerBox = ({ product }: DivorcePlannerBoxProps) => {
  if (product.isInitialProxy) {
    return null;
  }

  return (
    <ContentBox headline={"Scheidungsplaner"}>
      <Typography sx={{ marginBottom: "1rem" }}>
        Ihr persönlicher Scheidungsplaner passt sich über den gesamten Zeitraum der Scheidung immer an Ihre aktuelle Situation an. So haben Sie die nächsten
        Schritte im Blick und können Ihre Checklisten erledigen.
      </Typography>
      <Button color={"primary"} component={Link} to={getCaseLink(product) + "/scheidungsplaner"} endIcon={<ArrowForward />} sx={{ paddingLeft: 0 }}>
        Zum Scheidungsplaner
      </Button>
    </ContentBox>
  );
};

export default DivorcePlannerBox;
